import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'frDate',
  standalone: true,
})
export class FrDatePipe implements PipeTransform {
  datePipe = new DatePipe('fr-FR');
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return this.datePipe.transform(value, 'dd/MM/yyyy') ?? '';
  }
}
